import React, {useEffect} from 'react';
import autobind from 'autobind-decorator';

import {TextTableColumn} from "../../Common/Tables/TextTableColumn";

import {StreamBankTable} from "../../Common/Table/StreamBankTable";
import {PermitNameTableColumn} from "./NameTableColumn";
import {ContextTableColumn} from "./ContextTableColumn"
import DateUtils from "../../../../../monitoring/src/Utils/DateUtils";
import {DateTableColumn} from "../../Common";

export const PermitsTable = React.forwardRef((props, ref) => {

    const columnDefs = [
        {
            title: "Name / Number",
            key: "permitNumber",
            sortable: true,
            logic: (x) => x.permitNumber,
            renderer: PermitNameTableColumn,
        },
        {
            title: "Permit Organization",
            key: "permitOrganization",
            sortable: true,
            logic: (x) => x.PermitType.PermitOrganization.name,
            renderer: TextTableColumn
        },
        {
            title: "Permit Type",
            key: "permitType",
            sortable: true,
            logic: (x) => x.PermitType.name,
            renderer: TextTableColumn
        },
        {
            title: "Expiration Date",
            key: "expirationDate",
            sortable: true,
            logic: (x) => x.expirationDate,
            renderer: DateTableColumn,
            headerClassName: "long-date",
        },
        {
            title: "Context",
            key: "context",
            sortable: true,
            logic: (x) => x?.conservationActionName || 'N/A',
            renderer: ContextTableColumn,
        },
    ];;

    return <StreamBankTable
        columnDefs={columnDefs}
        itemNamePlural="permits"
        getKeyForRow={x => x.permitId}

        ref={ref}

        {...props}

    />;
});


